export default "__VITE_ASSET__Bgk4$NY$__"